// extracted by mini-css-extract-plugin
module.exports = {"banner":"groupConfigWarning_banner__3A2GG","inline":"groupConfigWarning_inline__2KE_H","icon":"groupConfigWarning_icon__XajWp","text":"groupConfigWarning_text__-LBK0"};